import { render, staticRenderFns } from "./LandOwnerSelection.vue?vue&type=template&id=2fc092c9"
import script from "./LandOwnerSelection.vue?vue&type=script&lang=js"
export * from "./LandOwnerSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports